import device from './device'
import http from './http'
import time from './time'
import browser from './browser'

export default {
    time,
    device,
    http,
    browser
}